export default __webpack_public_path__ + "static/media/shareEmail.edc05f45.svg";